/*
  Abandon-cart profile sync. Reads the best eligible cart item rendered by
  sections/ac-sync-data.liquid and writes it to the identified Klaviyo profile.
  Passive: never touches cart requests, never throws, no console output.
*/
(function () {
  try {
    if (window.__acSync) return; window.__acSync = true;
    if (window.Shopify && window.Shopify.designMode) return;

    var SECTION = 'ac-sync-data';
    var STORE_KEY = 'ac_sync_sig';
    var PREFIX = 'AC_CART10_';
    var DEBOUNCE = 800;
    var LOAD_GRACE = 5000;
    var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
    var UPDATE_RE = /\/cart\/update(\.js)?(\?|$)/;

    var last = null, timer = null, busy = false, again = false;

    function noop() {}
    function idle(fn) { (window.requestIdleCallback || function (f) { return setTimeout(f, 1500); })(fn); }
    function getStored() { try { return localStorage.getItem(STORE_KEY); } catch (e) { return null; } }
    function setStored(v) { try { localStorage.setItem(STORE_KEY, v); } catch (e) {} }
    function parse(text) { try { return JSON.parse(text); } catch (e) { return null; } }
    function sigOf(d) { return [d.name, d.url, d.image, d.price, d.compare].join('|'); }

    function push(d) {
      if (!d) return;
      last = d;
      // No eligible item: leave the profile as is. The flow checks cart eligibility before using these.
      if (!d.name) return;
      var sig = sigOf(d);
      if (getStored() === sig) return;
      var k = window.klaviyo;
      if (!k || typeof k.isIdentified !== 'function' || typeof k.identify !== 'function') return;
      Promise.resolve(k.isIdentified()).then(function (yes) {
        if (!yes) return;
        var props = {};
        props[PREFIX + 'Item_Name'] = d.name;
        props[PREFIX + 'Item_URL'] = d.url;
        props[PREFIX + 'Item_Image'] = d.image;
        props[PREFIX + 'Item_Price'] = d.price;
        props[PREFIX + 'Item_CompareAt'] = d.compare;
        props[PREFIX + 'Updated'] = new Date().toISOString();
        return Promise.resolve(k.identify(props)).then(function () { setStored(sig); });
      }).catch(noop);
    }

    function refresh() {
      if (busy) { again = true; return; }
      busy = true;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + '?sections=' + SECTION, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          var html = j && j[SECTION];
          var m = html && html.match(/<script[^>]*id="ac-sync-data"[^>]*>([\s\S]*?)<\/script>/);
          if (m) push(parse(m[1]));
        })
        .catch(noop)
        .then(function () { busy = false; if (again) { again = false; schedule(); } });
    }

    function schedule() { clearTimeout(timer); timer = setTimeout(refresh, DEBOUNCE); }

    // Theme and custom-module cart events (capture on window also sees events fired on document).
    ['eurus:cart:items-changed', 'cart:updated', 'cart:item_added', 'cart:refresh', 'bsb:added'].forEach(function (name) {
      window.addEventListener(name, schedule, true);
    });

    // Passive fallback for apps and modules that fire no event: notice completed cart requests.
    if (window.PerformanceObserver) {
      try {
        new PerformanceObserver(function (list) {
          var entries = list.getEntries();
          for (var i = 0; i < entries.length; i++) {
            var url = entries[i].name;
            if (!CART_RE.test(url)) continue;
            // /cart/update is mostly attribute writes (apps fire one on every page load).
            // Skip it when the cart is empty or the inline data is still fresh from page load.
            if (UPDATE_RE.test(url) && last && (!last.count || entries[i].startTime < LOAD_GRACE)) continue;
            schedule(); break;
          }
        }).observe({ type: 'resource' });
      } catch (e) {}
    }

    // Back/forward cache restores can show stale inline data.
    window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(); });

    // A shopper may identify mid-session through a Klaviyo form.
    window.addEventListener('klaviyoForms', function (e) {
      if (e && e.detail && e.detail.type === 'submit') setTimeout(function () { push(last); }, 3000);
    });

    // Read the inline data now (cheap) so early cart requests can be judged; push when idle.
    var el = document.getElementById('ac-sync-data');
    last = el ? parse(el.textContent) : null;
    function init() { push(last); }
    if (document.readyState === 'complete') idle(init);
    else window.addEventListener('load', function () { idle(init); });
  } catch (e) {}
})();
